<template>
    <div>
        <el-row :gutter="24"> 
          <el-col :span="6">
            <div class="block">
              <el-date-picker size="mini" v-model="params.times" clearable type="daterange" :picker-options="pickerOptions"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="7">
            <el-button type="primary" @click="searchData" size="mini">搜索</el-button>
            <el-button size="mini" type="primary" @click="getExport()">导出</el-button>
          </el-col>
        </el-row>
        <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
          <el-table-column prop="activity_id" label="活动id"></el-table-column>
          <el-table-column prop="chat_id" label="群聊ID"></el-table-column>
          <el-table-column prop="user_id" label="用户ID"></el-table-column> 
          <el-table-column prop="wx_user_id" label="员工编号"></el-table-column> 
          <el-table-column prop="created_at_text" label="创建时间"></el-table-column> 
        </el-table>
        <div class="content-center content-top-padded">
          <el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
            @size-change="handleSizeChange" :current-page.sync="params.page" :page-sizes="[10, 20, 50]" :total="total_count"
            :page-size="params.pagesize">
          </el-pagination>
        </div> 
    </div>
  </template>
  <script>
  import {
    mapGetters
  } from "vuex";
  import draggable from "vuedraggable";
  import {
    getNewCustomerWechatList,getWechatLogExport
  } from "@/api/promotions";
  export default {
    components: {
      draggable
    },
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        dialogVisible: false,
        total_count: 0,
        params: {
          page: 1,
          pagesize: 20,
        },
        dataList: [],
        loading: false,
      };
    },
    computed: {
      ...mapGetters(["wheight"]),
    },
    methods: { 
      getDataList() {
        this.loading = true;
        getNewCustomerWechatList(this.params)
          .then((response) => {
            this.dataList = response.data.data.list;
            this.total_count = response.data.data.total_count;
            this.loading = false;
          })
      },
      
      handleCurrentChange(page_num) {
        this.params.page = page_num;
        this.getDataList();
      },
      searchData() {
        this.params.page = 1;
        this.getDataList();
      },
      handleSizeChange(pageSize) {
        this.params.page = 1;
        this.params.pagesize = pageSize;
        this.getDataList();
      },
      getExport(){
        if (this.params.times == '') {
                this.$message({
                    type: 'error',
                    message: '请先选择日期!'
                });
                return false;
            }
            this.$notify({
                title: '成功',
                message: '正在导出,请稍后...',
                type: 'success'
            })
            getWechatLogExport(this.params).then(res => {
                      if (res.data.data.status) {
                          this.$notify({
                              title: '成功',
                              message: '正在导出请稍后!',
                              type: 'success'
                          })
                          var url = res.data.data.url
                          window.open(url)
                      } else {
                          this.$notify({
                              title: '失败',
                              message: '出错了!',
                              type: 'error'
                          })
                      }
                  })
      },
    },
    mounted() {
      this.getDataList();
    },
    provide() {
      return {
        refresh: this.getDataList
      }
    },
  
  };
  </script>
  <style scoped lang="scss"></style>
  


// WEBPACK FOOTER //
// wechatlog.vue?59be18d8